import { Record } from 'immutable';

const struct = {
  id:         undefined,
  name:       undefined,
  title:      undefined,
  folderType: undefined,
};

export default class FolderRecord extends Record(struct, 'FolderRecord') {

}
